











import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import PanelCustomer from '@/app/shared/components/panels/customer.vue';
import PanelContract from '@/app/shared/components/panels/contract-policy.vue';
import PanelPayment from '@/app/shared/components/panels/payment.vue';
import PanelProduct from '@/app/shared/components/panels/product.vue';
import PanelComplementary from '@/app/shared/components/panels/complementary.vue';
@Component({
  components: {
    PanelCustomer,
    PanelContract,
    PanelPayment,
    PanelProduct,
    PanelComplementary,
  },
})
export default class TabItemGeneralComponent extends Vue {
  private get refs() {
    return refsService;
  }
}
